export default __webpack_public_path__ + "static/media/Spring_elephant.e79e5bd5.png";